import { getArray, post, patch, removeList } from '../index'

export default {

  /**
   * Management user info
   */
  create: (id, userBody) => post(`/users/${id}`, userBody), // es el id del usuario padre
  update: (id, user) => patch(`/users/${id}`, user),
  remove: (array) => removeList('/users/{id}', array),

  /**
   * Get users list
   */
  list: (id, params) => getArray(`/users/${id}`, params),
  listMore: (url) => getArray(url),

  /**
   * User actions for passwords and tokens
   */
  recovery: (body) => post('/users/password/forgot', body, { headers: { isPublic: true } }),
  resetPass: (body) => post('/users/password/reset', body, { headers: { isPublic: true } }),
  activeToken: (body) => post('/users/token/active', body, { headers: { isPublic: true } }),

  /**
   * Get multiple users (only for RIOJA)
   */
  getMulticompany: (body) => getArray('/multicompany', body)
}
